<template>
  <div class="CourseDetails-introduce">
    <div class="banner"></div>
    <div class="introduceDet publick">
      <div class="txt fl">
        <span class="t">难度：中级</span>
        <span class="d">·</span>
        <span class="t">时长：12小时</span>
        <span class="d">·</span>
        <span class="t">学习人数：6652人</span>
      </div>
      <div class="student fr">
        <router-link tag="span" to="/liveLayer">立即预约</router-link>
      </div>
      <!--      <div class="student fr">查看直播</div>-->
    </div>
    <div class="Tab">
      <li @click="TabClick(0)" :class=" TabIndex === 0 ? 'choice':'' ">
        <p class="t">课程介绍</p>
        <p class="b"></p>
      </li>
      <li @click="TabClick(1)" :class=" TabIndex === 1 ? 'choice':'' ">
        <p class="t">课堂笔记</p>
        <p class="b"></p>
      </li>
      <li @click="TabClick(2)" :class=" TabIndex === 2 ? 'choice':'' ">
        <p class="t">评论<b>89</b></p>
        <p class="b"></p>
      </li>
    </div>
    <div class="content">
      <introduce v-if="TabIndex === 0"></introduce>
      <notes v-if="TabIndex === 1"></notes>
      <comments v-if="TabIndex === 2"></comments>
    </div>
    <layerRight></layerRight>
  </div>
</template>

<script>
  import introduce from '@/components/live/introduce/introduce'
  import comments from '@/components/live/comments/comments'
  import layerRight from '@/components/layerRight/layerRight'
  import notes from '@/components/CourseDetails/notes/notes'

  export default {
    components: {
      introduce,
      notes,
      comments,
      layerRight
    },
    data () {
      return {
        TabIndex: 0,
        id: '',
        info: {},
        pushcourse: []
      }
    },
    created () {
      this.id = this.$route.query.id
      this.getData()
      this.getCourse()
    },
    methods: {
      TabClick (index) { // tab切换
        this.TabIndex = index
      },
      getCourse () {
        this.$http.post('/apipx/Course/pushcourse', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.pushcourse = res.data
          }
        })
      },
      getData () {
        this.$http.post('/apipx/Course/info', {
          px_course_id: this.id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .CourseDetails-introduce {
    .layerRight {
      position: fixed;
      right: 0;
      top: 480px;
      width: 75px;
      height: 385px;
      box-shadow: 0px 0px 20px #f3f3f3;
      background-color: #fff;
      overflow: hidden;

      .t {
        height: 95px;
        border-bottom: 1px solid #d8d8d8;
        width: 35px;
        margin: 0 auto;
        overflow: hidden;

        img {
          display: block;
          margin: 22.5px auto 0;
        }

        &:last-child {
          border: 0;
        }
      }
    }

    .banner {
      width: 100%;
      height: 345px;
      background: url("../banner.png") no-repeat center center;
    }

    .introduceDet {
      height: 170px;
      margin: -85px auto 0;
      background-color: #fff;
      border-radius: 20px;
      box-shadow: 0px 0px 20px #fff0ef;

      .txt {
        font-size: 18px;
        height: 25px;
        line-height: 25px;
        margin: 72.5px 0px 0px 80px;

        .d {
          color: #ff8484;
          margin: 0 10px;
        }
      }

      .student {
        width: 145px;
        height: 65px;
        background-color: #ff8484;
        border-radius: 30px;
        color: #fff;
        font-size: 18px;
        margin: 52.5px 80px 0 0;
        cursor: pointer;
        text-align: center;
        line-height: 65px;
        box-shadow: 0px 0px 20px #f9a9a9;

        &:hover {
          background-color: #f9a9a9;
        }
      }
    }

    .Tab {
      width: 650px;
      overflow: hidden;
      margin: 50px auto 40px;

      li {
        width: 150px;
        height: 40px;
        position: relative;
        line-height: 40px;
        float: left;
        margin: 0 0 0 50px;
        text-align: center;
        cursor: pointer;

        .t {
          b {
            font-weight: normal;
            position: absolute;
            right: 45px;
            top: 5px;
            font-size: 12px;
            color: #b3b3b3;
            line-height: 10px;
          }
        }

        .b {
          background-color: #fff;
          width: 20px;
          height: 3px;
          position: absolute;
          left: 50%;
          bottom: 0;
          margin: 0 0 0 -10px;
        }

        &.choice {

          .b {
            background-color: #ff8484;
          }

          .t {
            color: #ff8484;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/live/details/details.vue